module.exports = __webpack_public_path__ + "img/uploaddemo-2-a.82276115.png";